import { IFinal, ITranscriptWord } from '../components/Editor/IEditor';
import {
  IV3RecievedTranscript,
  IReceivedTranscript,
  IV3RecievedToken,
  IV3RecievedMessage,
  IV3RecievedMappedTranscript,
} from '../components/Libraries/ILibraries';

const isPunctuation = (textValue: string) =>
  textValue === '.' ||
  textValue === '?' ||
  textValue === '!' ||
  textValue === ',' ||
  textValue === ':' ||
  textValue === ';';
const isPunctuationCommand = (textValue: string) =>
  textValue === '<.>' ||
  textValue === '<?>' ||
  textValue === '<!>' ||
  textValue === '<,>' ||
  textValue === '<:>' ||
  textValue === '<;>';
const convertPunctuationCommand = (textValue: string) => {
  switch (textValue) {
    case '<.>':
      return '.';
    case '<?>':
      return '?';
    case '<!>':
      return '!';
    case '<,>':
      return ',';
    default:
      return textValue;
  }
};
const isCommand = (textValue: string) => textValue.startsWith('<') && textValue.endsWith('>');

export const convertFromVersion3ToVersion2File = (data: IV3RecievedMappedTranscript[]): IFinal[] => {
  let capitalizeNext = false;

  return data.map((transcript) => {
    return {
      content: transcript.tokens.map((token, index, tokens) => {
        // Determine if there should be a space before this token
        let spaceBefore = false;

        const previousTokenIsRightHanded = index > 0 ? tokens[index - 1].isRightHanded ?? false : false;
        const currentTokenIsLeftHanded = token.isLeftHanded ?? false;
        spaceBefore = !previousTokenIsRightHanded && !currentTokenIsLeftHanded;

        if (isPunctuation(token.text) || isPunctuationCommand(token.text)) {
          /*if (transcript.isFinal) {
                        capitalizeNext = true
                    }*/

          return {
            startTime: (transcript.startTimeMs + token.startOffsetMs) / 1000,
            endTime: (transcript.startTimeMs + token.endOffsetMs) / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text: isPunctuationCommand(token.text) ? convertPunctuationCommand(token.text) : token.text,
            spaceBefore: spaceBefore,
            speaker: token.speaker,
          };
        } else if (!isCommand(token.text)) {
          let text = capitalizeNext ? token.text.toUpperCase() : token.text;
          capitalizeNext = false;
          return {
            startTime: (transcript.startTimeMs + token.startOffsetMs) / 1000,
            endTime: (transcript.startTimeMs + token.endOffsetMs) / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text,
            spaceBefore: spaceBefore,
            speaker: token.speaker,
          };
        } else {
          return {
            startTime: (transcript.startTimeMs + token.startOffsetMs) / 1000,
            endTime: (transcript.startTimeMs + token.endOffsetMs) / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text: token.text,
            spaceBefore: spaceBefore,
            speaker: token.speaker,
          };
        }
      }),
    };
  });
};
export const convertFromVersion3ToVersion2 = (
  data: IV3RecievedMessage,
  textSegment: IV3RecievedMappedTranscript,
  shouldCapitalizeFirst: boolean
): IReceivedTranscript => {
  let capitalizeNext = shouldCapitalizeFirst;

  return {
    type: data.type,
    isFinal: textSegment.isFinal,
    decoded: textSegment.endTimeMs / 1000,
    transcript: {
      id: 0,
      content: textSegment.tokens.map((token, index, tokens) => {
        // Determine if there should be a space before this token
        let spaceBefore = false;

        const previousTokenIsRightHanded = index > 0 ? tokens[index - 1].isRightHanded ?? false : false;
        const currentTokenIsLeftHanded = token.isLeftHanded ?? false;
        spaceBefore = !previousTokenIsRightHanded && !currentTokenIsLeftHanded;

        if (isPunctuation(token.text) || isPunctuationCommand(token.text)) {
          if (textSegment.isFinal && token.text !== ',' && token.text !== '<,>') {
            capitalizeNext = true;
          }

          return {
            startTime: token.startOffsetMs / 1000,
            endTime: token.endOffsetMs / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text: isPunctuationCommand(token.text) ? convertPunctuationCommand(token.text) : token.text,
            spaceBefore: spaceBefore,
            speaker: token.speaker
          } as ITranscriptWord;
        } else if (!isCommand(token.text)) {
          let text = capitalizeNext ? token.text.charAt(0).toUpperCase() + token.text.slice(1) : token.text;
          capitalizeNext = false;

          return {
            startTime: token.startOffsetMs / 1000,
            endTime: token.endOffsetMs / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text,
            spaceBefore: spaceBefore,
            speaker: token.speaker
          } as ITranscriptWord;
        } else {
          return {
            startTime: token.startOffsetMs / 1000,
            endTime: token.endOffsetMs / 1000,
            confidence: token.confidence ? token.confidence : 0,
            text: token.text,
            spaceBefore: spaceBefore,
            speaker: token.speaker
          } as ITranscriptWord;
        }
      }),
    },
  } as IReceivedTranscript;
};

export const convertFromVersion2ToVersion3 = (data: IReceivedTranscript): IV3RecievedTranscript => {
  const firstContent = data.transcript.content[0] as ITranscriptWord;
  const lastContent = data.transcript.content[data.transcript.content.length - 1] as ITranscriptWord;

  return {
    type: data.type,
    isFinal: data.isFinal,
    startTimeMs: firstContent.startTime * 1000,
    endTimeMs: lastContent.endTime * 1000,
    tokens: (data.transcript.content as ITranscriptWord[]).map((transcript) => {
      return {
        startOffsetMs: (transcript.startTime - firstContent.startTime) * 1000,
        endOffsetMs: (transcript.endTime - firstContent.startTime) * 1000,
        text: transcript.text,
      } as IV3RecievedToken;
    }),
  } as IV3RecievedTranscript;
};
